import {useNavigate} from 'react-router-dom';
import {OnboardingLayout} from './OnboardingLayout';
import {Button} from '@/components';
import styles from './Onboarding.module.css';

export function ComingSoon() {
  const navigate = useNavigate();

  return (
    <OnboardingLayout currentStep={3} totalSteps={4}>
      <h2 className={styles.stepTitle}>Coming soon</h2>
      <p className={styles.stepDescription}>
        Thanks for your interest! Today we can only perform our automated service
        with Gmail, but we'll record your need and keep you posted as we add other
        email providers. If you have a Gmail account, feel free to go back and set
        up that way.
      </p>
      <div className={styles.backBtnRow}>
        <Button onClick={() => navigate('/connect-email')}>
          ← Back to email options
        </Button>
      </div>
    </OnboardingLayout>
  );
}
